"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const isToday_1 = __importDefault(require("date-fns/isToday"));
const isYesterday_1 = __importDefault(require("date-fns/isYesterday"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("../../utils");
var Day;
(function (Day) {
    Day["Today"] = "today";
    Day["Yesterday"] = "yesterday";
})(Day || (Day = {}));
const convertToDateFormat = (timestamp) => {
    const now = new Date();
    const date = new Date(timestamp);
    let dateString = date.toLocaleDateString(i18n_1.i18n.language, {
        month: 'long',
        day: 'numeric',
    });
    if (date.getFullYear() < now.getFullYear()) {
        dateString += ', ' + date.getFullYear();
    }
    return dateString;
};
function NotificationsList({ notificationsExtraData, notifications = [], onSelect, }) {
    const sortedNotifications = notifications
        .map(notification => {
        const clone = Object.assign(Object.assign({}, notification), { date: convertToDateFormat(notification.timestamp) });
        if ((0, isToday_1.default)(notification.timestamp))
            clone.date = Day.Today;
        if ((0, isYesterday_1.default)(notification.timestamp))
            clone.date = Day.Yesterday;
        return clone;
    })
        .sort((current, next) => next.timestamp - current.timestamp);
    const groupedByDate = Object.entries((0, lodash_1.groupBy)(sortedNotifications, 'date'));
    const hasSelected = Object.values(notificationsExtraData).some(item => item.selected === true);
    const notificationDateLabel = (date) => {
        switch (date) {
            case Day.Today:
                return (0, i18n_1.Localized)(i18n_1.Strings.dates.today);
            case Day.Yesterday:
                return (0, i18n_1.Localized)(i18n_1.Strings.dates.yesterday);
            default:
                return date;
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'NotificationsList_Container', children: groupedByDate.map(([timestamp, notices], index) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider, { "data-e2e": 'NotificationsList_Divider', children: notificationDateLabel(timestamp) }), (0, jsx_runtime_1.jsx)("div", { "data-e2e": 'NotificationsList_div', children: (0, utils_1.renderNotifications)(notices, onSelect, notificationsExtraData, hasSelected) }, timestamp + index)] }, index))) }));
}
exports.default = NotificationsList;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.designSystem.background};
  justify-content: left;
`;
const Divider = styled_components_1.default.span `
  display: flex;
  color: ${props => props.theme.designSystem.textSecondary};
  margin-left: 24px;
  padding-top: 8px;
  margin-bottom: 5px;
  font-size: 14px;
  text-transform: capitalize;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-left: 68px;
  `)};
`;
